import { FaCogs, FaChartLine, FaRobot, FaDocker, FaNetworkWired, FaMobileAlt, FaUserShield, FaClock, FaVolumeMute, FaShieldAlt, FaCubes } from "react-icons/fa";
import { IconMicrophoneOff, IconUnlock, IconApps } from '@douyinfe/semi-icons';

export const solutions = [
    {
        id: 1,
        name: "Ianus: Your Personal Privacy Shield",
        description: "Ianus generates white noise to protect your conversations from unwanted recordings, ensuring privacy in real-time.",
        icon: <IconMicrophoneOff />,
        types: [
            { name: "Privacy Protection", icon: <FaUserShield /> },
            { name: "Audio Security", icon: <FaVolumeMute /> },
            { name: "Mobile App", icon: <FaMobileAlt /> },
            { name: "Real-Time", icon: <FaClock /> }
        ],
        category: {
            name: "Privacy Tools",
            icon: <FaShieldAlt />
        },
        requirements: {
            ios: {
                minimum: {
                    os_version: "iOS 13.0",
                    storage: "50 MB",
                    hardware: "iPhone 6s or later"
                },
                recommended: {
                    os_version: "iOS 16.0 or later",
                    storage: "100 MB",
                    hardware: "iPhone 11 or later"
                }
            },
            android: {
                minimum: {
                    os_version: "Android 8.0 (Oreo, API 26)",
                    storage: "50 MB",
                    ram: "2 GB"
                },
                recommended: {
                    os_version: "Android 12 or later (API 31)",
                    storage: "100 MB",
                    ram: "4 GB"
                }
            },
            server: null,
            additional: {
                internet: "Optional (for updates or additional sound profiles)",
                notes: "Performance may vary on older devices; ensure microphone and speaker are functional."
            }
        },
        buttons: {
            info: {
                enable: true,
                text: "Info"
            },
            download: {
                enable: true,
                link: null
            },
            google_play: {
                enable: true,
                link: null
            },
            app_store: {
                enable: true,
                link: null
            },
            external_link: {
                enable: true,
                link: null
            }
        }
    },
    {
        id: 2,
        name: "Entropy: Your Automation Powerhouse",
        description: "1C Cluster Manager automates your 1C cluster in Docker, offering seamless scaling, monitoring, and load balancing for peak business efficiency.",
        icon: <FaCubes />,
        types: [
            { name: "Cluster Management", icon: <FaNetworkWired /> },
            { name: "Containerized", icon: <FaDocker /> },
            { name: "Automation", icon: <FaRobot /> },
            { name: "Business Efficiency", icon: <FaChartLine /> }
        ],
        category: {
            name: "Automation Tools",
            icon: <FaCogs />
        },
        requirements: {
            ios: null,
            android: null,
            server: {
                minimum: {
                    os: "Ubuntu 20.04 LTS / Debian 10 (Buster) / CentOS 8",
                    cpu: "4 cores (e.g., Intel Xeon E3 or equivalent)",
                    ram: "16 GB",
                    storage: "20 GB HDD (SSD recommended)"
                },
                recommended: {
                    os: "Ubuntu 22.04 LTS / Debian 11 (Bullseye) / CentOS 9 / Red Hat Enterprise Linux 8",
                    cpu: "8 cores (e.g., Intel Xeon E5 or equivalent)",
                    ram: "32 GB",
                    storage: "50 GB SSD"
                }
            },
            additional: {
                internet: "Optional (for updates or additional sound profiles)",
                notes: "Performance depends on cluster size and user load; SSD strongly recommended for database and Docker storage."
            }
        },
        buttons: {
            info: {
                enable: true,
                text: "Info"
            },
            download: {
                enable: true,
                link: null
            },
            google_play: {
                enable: false,
                link: null
            },
            app_store: {
                enable: false,
                link: null
            },
            external_link: {
                enable: true,
                link: null
            }
        }
    },
    {
        id: 3,
        name: "CyberVault: Your digital sanctuary",
        description: "Secure virtualization environment that uses encrypted virtual files to isolate and run subsets of files and applications.",
        icon: <IconApps />,
        types: [
            { name: "Privacy Protection", icon: <FaUserShield /> }
        ],
        category: {
            name: "Security",
            icon: <IconUnlock />
        },
        requirements: {
            ios: null,
            android: null,
            server: {
                minimum: {
                    os: "Windows 11 / CentOS 10",
                    cpu: "4 cores",
                    ram: "16 GB",
                    storage: "35 GB HDD (SSD recommended)"
                },
                recommended: {
                    os: "Windows 11 / CentOS 10",
                    cpu: "4 cores",
                    ram: "32 GB",
                    storage: "80 GB SSD"
                }
            },
            additional: {
                internet: "Optional (for updates)",
                notes: "Performance may vary on older devices."
            }
        },
        buttons: {
            info: {
                enable: true,
                text: "Info"
            },
            download: {
                enable: true,
                link: null
            },
            google_play: {
                enable: false,
                link: null
            },
            app_store: {
                enable: false,
                link: null
            },
            external_link: {
                enable: true,
                link: null
            }
        }
    },
];